import type { ChangeEvent } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { RadioGroup } from '~/components/RadioGroup';
import { TRACK_ROLE_OPTIONS } from '~/modules/artist-roster/pages/artist-details/utils/constants';
import type { TrackRoleType } from '~/modules/artist-roster/pages/artist-details/utils/types';

type TrackRoleOrAllType = TrackRoleType | 'all';

export function TrackRoleFilter() {
  const { t } = useTranslation('roster');
  const { watch, setValue } = useFormContext();
  const filterKey = 'role';
  const filterValue: TrackRoleOrAllType = watch(filterKey) || 'all';

  const handleTagClick = (event: ChangeEvent<HTMLInputElement>) => {
    setValue(filterKey, event.target.value, {
      shouldDirty: true,
    });
  };

  return (
    <RadioGroup
      className="py-sm"
      options={[
        {
          value: 'all',
          label: t('all.label'),
        },
        ...TRACK_ROLE_OPTIONS.map((type) => ({
          value: type,
          label: <>{t(`filters.role.${type}`)}</>,
        })),
      ]}
      name={filterKey}
      value={filterValue}
      onChange={handleTagClick}
    />
  );
}

TrackRoleFilter.displayName = 'TrackRoleFilter';
